import { useForm } from "react-hook-form";
import "./password-top-client.css";
import axios from "axios";
import Swal from "sweetalert2";

function PasswordTopClient() {

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitted }
  } = useForm({
    defaultValues: {
      password: ""
    }
  });

  const handleChangePassword = async (data) => {
    const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_ADMIN}/top_client`;
    const body = {"password": data.password}
    
    try {
      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      })
      Swal.fire({
        title: "Contraseña actualizada correctamente",
        icon: "success",
        confirmButtonColor: "#3085d6",
      });
      reset();
    } catch (error) {
      Swal.fire({
        title: "Error al cambiar contraseña",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
      reset();
    }
  }

  return(
    <>
      <h3 className="text-center">Cambio de contraseña</h3>
      <p className="info-tc">Cambio de contraseña para el modulo de colocador en clientes top de carga pesada</p>

      <div className="form-content-ptc">
        <form 
          autoComplete="off" 
          onSubmit={handleSubmit(handleChangePassword)}
        >
          <label>Ingresa la nueva contraseña: </label>
          <input 
            type="password"
            autoComplete="new-password"
            id="password"
            {...register("password", {
              required: true
            })}
          />

          <button>
            Cambiar Contraseña
          </button>
        </form>
      </div>
    </>
  )
}

export default PasswordTopClient;